export { default } from './ServiceMenu';
